import { useState, useEffect, useCallback } from "react";
import { Outlet, useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import BreadCrumb from "components/utils/BreadCrumb.js";
import withRouter from "components/utils/withRouter.js";
import PathUtils from "utils/PathUtils.js";
import { useOutletContext } from "react-router-dom";
import useResolvedHospitalId from "hooks/useResolvedHospitalId.js";

function ScheduleManagement() {
  const [breadCrumbPathElements, setBreadCrumbPathElements] = useState([
    "Home",
    "Schedule Management",
  ]);

  const location = useLocation();
  const [contextHospitalId] = useOutletContext();
  const { hospitalId, isResolving, resolveError } = useResolvedHospitalId({
    contextHospitalId,
    syncRedux: true,
  });

  const updateBreadCrumbPath = useCallback(() => {
    let updatedBreadCrumbPathElements = PathUtils.extractBreadCrumbTokens(
      location.pathname
    );
    setBreadCrumbPathElements(updatedBreadCrumbPathElements);
  }, [location]);

  useEffect(() => {
    updateBreadCrumbPath();
  }, [location, updateBreadCrumbPath]);

  if (isResolving) {
    return (
      <div className="d-flex justify-content-center py-5">
        <CircularProgress />
      </div>
    );
  }

  if (resolveError || !hospitalId) {
    return (
      <div className="d-flex justify-content-center py-5 px-3">
        <p className="text-danger mb-0">{resolveError || "No centre is available."}</p>
      </div>
    );
  }

  return (
    <div>
      <BreadCrumb pathElements={breadCrumbPathElements} />
      <Outlet context={[hospitalId]} />
    </div>
  );
}

export default withRouter(ScheduleManagement);
